export const IO_ADD_INSURANCE_TARGET = 'IO_ADD_INSURANCE_TARGET';
export const IO_CHANGE_VIEW = 'IO_CHANGE_VIEW';
export const IO_DELETE_ALL_INSURANCES = 'IO_DELETE_ALL_INSURANCES';
export const IO_DELETE_INSURANCE_TARGET = 'IO_DELETE_INSURANCE_TARGET';
export const IO_SAVE_AT_LEAST_ONE_TARGET = 'IO_SAVE_AT_LEAST_ONE_TARGET';
export const IO_SEND_INSURANCE_OFFER_REQUEST =
  'IO_SEND_INSURANCE_OFFER_REQUEST';
export const SHARED_CHANGE_VALID_INPUT_DATA = 'SHARED_CHANGE_VALID_INPUT_DATA';
export const SHARED_CHANGE_VALID_INPUT_ERROR =
  'SHARED_CHANGE_VALID_INPUT_ERROR';
export const SHARED_DISABLE_ANIMATE_ON_INPUT_FIELD =
  'SHARED_DISABLE_ANIMATE_ON_INPUT_FIELD';
export const SHARED_EMPTY_VALUE_ERROR_AND_ANIMATE_INPUT =
  'SHARED_EMPTY_VALUE_ERROR_AND_ANIMATE_INPUT';
export const SHARED_HIDE_OPAS_LINK_INTERRUPTED_MODAL =
  'SHARED_HIDE_OPAS_LINK_INTERRUPTED_MODAL';
export const SHARED_SHOW_OPAS_LINK_INTERRUPTED_MODAL =
  'SHARED_SHOW_OPAS_LINK_INTERRUPTED_MODAL';
export const SHARED_START_GLOBAL_SPINNER = 'SHARED_START_GLOBAL_SPINNER';
export const SHARED_STOP_GLOBAL_SPINNER = 'SHARED_STOP_GLOBAL_SPINNER';
export const SHARED_TECHNICAL_ERROR = 'SHARED_TECHNICAL_ERROR';
export const SHARED_RESET_STORE = 'SHARED_RESET_STORE';
export const IO_CHANGE_INSURANCE = 'IO_CHANGE_INSURANCE';
export const IO_CHANGE_CONTACTINFO = 'IO_CHANGE_CONTACTINFO';
export const IO_CHANGE_SHOWCONTACTINFO = 'IO_CHANGE_SHOWCONTACTINFO';
export const IO_CHANGE_SHOWINSURANCEERRORMESSAGE =
  'IO_CHANGE_SHOWINSURANCEERRORMESSAGE';
export const IO_CHANGE_SHOWCQUESTIONS = 'IO_CHANGE_SHOWCQUESTIONS';
export const IO_CHANGE_SHOWEXCEPTIONMESSAGE = 'IO_CHANGE_SHOWEXCEPTIONMESSAGE';
export const IO_UPDATE_SEND_VALUE = 'IO_UPDATE_CHANGE_VALUE'
export const DEFAULT = 'DEFAULT';
